// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.push-config fieldset[data-v-2bd6f010] {\n  background: #fff;\n  border: #e6ebf5 solid 2px;\n  border-radius: 5px;\n  padding: 10px 30px;\n}\n.push-config fieldset legend[data-v-2bd6f010] {\n  font-size: 14px;\n  padding-top: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
